import React, { useMemo } from "react";
import { Editor } from "@tinymce/tinymce-react";

const FONT_FAMILIES = [
  { label: "Default", value: "Helvetica Neue, Helvetica, Arial, sans-serif" },
  { label: "Traditional Arabic", value: "Traditional Arabic, serif" },
  { label: "Times New Roman", value: "Times New Roman, Times, serif" },
  { label: "Tahoma", value: "Tahoma, Geneva, sans-serif" },
  { label: "Courier New", value: "Courier New, monospace" },
];

const FONT_SIZES = ["10px", "12px", "14px", "16px", "18px", "24px", "32px"];

const TinyEditor = ({
  value,
  onChange,
  direction = "LTR",
  minHeight = 300,
}) => {
  const fontFormats = useMemo(
    () => FONT_FAMILIES.map((f) => `${f.label}=${f.value}`).join("; "),
    []
  );
  const fontsizeFormats = useMemo(() => FONT_SIZES.join(" "), []);

  const editorConfig = {
    height: minHeight,
    menubar: false,
    branding: false,
    promotion: false,
    license_key: "gpl",
    plugins: [
      "advlist",
      "autolink",
      "lists",
      "link",
      "image",
      "media",
      "charmap",
      "preview",
      "anchor",
      "searchreplace",
      "visualblocks",
      "code",
      "table",
      "wordcount",
      "autoresize",
      "directionality",
      "fullscreen",
    ],
    toolbar:
      "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough forecolor backcolor | " +
      "alignleft aligncenter alignright alignjustify | ltr rtl | bullist numlist outdent indent | " +
      "link image media | table | removeformat | code preview fullscreen",

    // ✅ Local image upload
    images_upload_handler: function (blobInfo, progress) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject({ message: "Image read failed" });
        reader.readAsDataURL(blobInfo.blob());
      });
    },
  };

  return (
    <Editor
      tinymceScriptSrc="/tinymce/tinymce.min.js"
      value={value || ""}
      init={{
        ...editorConfig,
        skin_url: "/tinymce/skins/ui/oxide",
        content_css: "/tinymce/skins/content/default/content.css",
      }}
      onEditorChange={(content) => onChange && onChange(content)}
    />
  );
};

export default TinyEditor;
